import React, {Component} from 'react';
import Slider from "react-slick";
import {REQUEST_CAROUSEL_DATA} from "../../actions/carouseActions";
import {connect} from "react-redux";
import Skeleton from "../Skeleton/Skeleton";
import CarouselLinkRenderer from "./CarouselLinkRenderer";
import ContentRenderer from "../ContentRenderer/ContentRenderer";

const mapStateToProps = state => {
  return {
    carouselData: state.carouselData
  }
};

const mapDispatchToProps = dispatch => ({
  getCarouselData: () => dispatch({type: REQUEST_CAROUSEL_DATA})
});

class Carousel extends Component {

  componentDidMount() {
    if (!this.props.carouselData.carousel) {
      this.props.getCarouselData();
    }
  };

  settings = {
    autoplay: true,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    showArrows: true,
    centerMode: false
  };

  state = {
    smallScreen: false,
    mediumScreen: false,
    largeScreen: false
  };

  componentDidUpdate(prevProps) {

    if (!prevProps.carouselData.carousel && this.props.carouselData.carousel) {
      this.carouselImages = this.props.carouselData.carousel.map((item) => {
        return item.image ? item.image : ''
      });
    }
  }

  getCarouselView = () => {

    const carouselItems = this.props.carouselData.carousel;

    return (
      <div className="carousel-container">
        <Slider {...this.settings}>
          {
            carouselItems.map((item, index) => {
              return (
                <div key={index} className="carousel-item-container">
                  <CarouselLinkRenderer
                    contentType={item.link ? item.link.type : null}
                    value={item.link ? item.link.url : null}
                    linkContent={
                      <ContentRenderer
                        contentType={item.content ? item.content.type : null}
                        value={item.content ? item.content.value : null}
                      />
                    }
                    target={item.link ? item.link.target : null}
                    id={item.id}
                  />
                </div>
              )
            })
          }
        </Slider>
      </div>
    )
  };

  render() {
    if (!this.props.carouselData.carousel) {
      return (<Skeleton type="CAROUSEL"/>)
    } else {
      return this.getCarouselView();
    }
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Carousel));



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js